import React, { useEffect, useState } from 'react'

import Lead from '../../display/Lead'
import { ContentWrapper, ContentWrapperInner, ContentFooter } from '../../layout/Wrapper'
import ContentFooterLink from '../../interactive/ContentFooterLink'

import { fetch } from '../../../modules/utils'
import { trackEvent } from '../../../modules/tracking'

export default function QualificationLandingPage({ userEmail, dashboardPath }) {
  const [qualificationStatus, setQualificationStatus] = useState(null)
  const [financeFailureType, setFinanceFailureType] = useState(null)

  useEffect(() => {
    fetch('GET', '/qualification_status', 'application/json').then(response => {
      setQualificationStatus(response.qualification_status)
      setFinanceFailureType(response.finance_failure_type)
    })

    trackEvent('Viewed the Qualification Landing Page')
  }, [])

  const getFinanceFailureMessage = () => {
    if (financeFailureType === 'bankruptcy') {
      return "that you've been made bankrupt"
    } else if (financeFailureType === 'limited_company') {
      return 'that you have a Limited Company'
    } else {
      return 'about some finance that might affect your claim'
    }
  }

  const content = {
    failed_on_finance: {
      leadText:
        "One of our agents <strong>will be in touch</strong> with you to get some more details about what you've told us.",
      body: `<p>You’re seeing this message because you told us ${getFinanceFailureMessage()}. We need to check a few more details to understand if you're still eligible to make a claim.</p>`,
      link: {
        href: 'https://www.riftrefunds.co.uk',
        text: 'Go to the RIFT homepage'
      },
      newStyle: false
    },
    failed: {
      leadText: `You're so close to unlocking your Tax Refund! We just need to ask a couple of additional questions.`,
      body: `
        <div class="qualification-landing__para">
          <h3>What happens next...</h3>
          <p>We'll give you a call, so keep an eye out for our number below</p>
          <p><strong><a href='tel:+441233628648'>01233 628648</a>.</strong></p>
        </div>
        <div class="qualification-landing__para">
          <h3>One step closer to your Tax Refund...</h3>
          <p>Once we've got those answers we can tell you the next steps and the best ways to get the ball rolling.</p>
        </div>
        <small><i>Note: No need to worry - this is super common. Our experts find it's much faster to chat than to send you more forms.</i></small>
      `,
      link: {
        href: dashboardPath,
        text: 'Go to home'
      },
      newStyle: true
    },
    passed: {
      leadText: `The hard part is over - now it's just a quick signature! We will email you three forms that let our personal tax specialists handle all the paperwork for you.`,
      body: `
        <div class="qualification-landing__para">
          <ul class='bullet-list'>
            <li>The first one (64-8) lets us talk to HMRC on your behalf</li>
            <li>The second one (SA1) allows us to submit everything to HMRC once you have confirmed you are happy with your claim</li>
            <li>The third one is our Terms & Conditions</li>
          </ul>
        </div>
        <div class="qualification-landing__para">
          <h3>What happens next...</h3>
          <ol class='number-list'>
            <li>Look out for an email sent to <strong>${userEmail}</strong>.</li>
            <li>It will be sent via DocuSign (check junk folder just in case).</li>
            <li>Double-check these details and fill in any blanks:
              <ul class='bullet-list' style='margin-bottom:0'>
                <li>Your name and address</li>
                <li>Your National Insurance number</li>
                <li>Your Date of Birth</li>
              </ul>
            </li>
            <li>Follow the instructions and sign.</li>
            <li>One of our tax specialists will be in touch with you. You can track the
              progress of your claim at any time using the MyRIFT app. Keep an eye on
              your emails - we’ll let you know which documents you can upload to help
              speed things up.
            </li>
          </ol>
        </div>
        <small><i>*You have 14 days after the date we confirm to you that we have accepted your
        64-8 form to change your mind. If you change your mind, please contact us by</i></small>
      `,
      link: {
        href: dashboardPath,
        text: 'Go to home'
      },
      newStyle: true
    }
  }

  const bodyClass = isNewStyle => {
    return isNewStyle ? 'qualification-landing__body' : 'mt-4'
  }

  return (
    qualificationStatus && (
      <ContentWrapper modifiers="small">
        <ContentWrapperInner modifiers="longform">
          <div className={content[qualificationStatus].newStyle ? 'qualification-landing' : ''}>
            <Lead dangerouslySetInnerHTML={{ __html: content[qualificationStatus].leadText }} />
            <div
              className={bodyClass(content[qualificationStatus].newStyle)}
              dangerouslySetInnerHTML={{ __html: content[qualificationStatus].body }}
            />
          </div>
        </ContentWrapperInner>
        <ContentFooter>
          <ContentFooterLink
            href={content[qualificationStatus].link.href}
            children={content[qualificationStatus].link.text}
          />
        </ContentFooter>
      </ContentWrapper>
    )
  )
}
